<template><div class="fit">
<div id="q-app" ref="mapContainer" class="fit"></div>

</div></template>

<script setup lang="ts">
import type ymaps from 'yandex-maps';
import {getCurrentInstance, onMounted, onUnmounted, ref, watch} from 'vue';
import {AreArraysEqualShallow} from "./Utils"

const self = getCurrentInstance();

const props = defineProps({
	pointAddresses: {type: Array<String>}
});

const mapContainer = ref(null);
let multiRoute: ymaps.multiRouter.MultiRoute;

const init = () => {
	const myMap = new ymaps.Map(mapContainer.value, {
		center: [55, 38.5],
		zoom: 8,
		controls: []
	});

	const zoomControl = new ymaps.control.ZoomControl({
		options: {
			size: 'small',
			float: 'none',
			position: {
				bottom: 145,
				right: 10
			}
		}
	});

	myMap.controls.add(zoomControl);

    // Создаем мультимаршрут и настраиваем его внешний вид с помощью опций.
    multiRoute = new ymaps.multiRouter.MultiRoute({
        referencePoints: [],
        params: {}
    }, {

    });
	myMap.geoObjects.add(multiRoute);

	multiRoute.model.events.add('requestsuccess', () => {
		const activeRoute = multiRoute.getActiveRoute();
		const waypoints = multiRoute.getWayPoints().toArray().map(waypoint => waypoint.properties.get("geocoderMetaData", {})?.Address);
		console.log(waypoints);
		self.emit("waypointsChanged", waypoints);
		if(!activeRoute)
		{
			self.emit("routeDistanceChanged", null);
			return;
		}
		const length = activeRoute.properties.get("distance", null); // .value в метрах
		self.emit("routeDistanceChanged", length.value / 1000);

		const balloonContentLayout = ymaps.templateLayoutFactory.createClass(
			'<span>Расстояние: ' + length.text + '.</span>');
		multiRoute.options.set('routeBalloonContentLayout', balloonContentLayout);
		activeRoute.balloon.open();
	});
	multiRoute.model.events.add('requestfail', () => {
		self.emit("routeDistanceChanged", null);
	});
}

onMounted(() => {
	ymaps.ready(init);

	let oldValue = [];
	watch(() => props.pointAddresses, (newValue: string[]) => {
		console.log("changed", newValue, oldValue);
		const filter = arr => [...new Set<string>(arr.filter(w => w?.length))];
		newValue = filter(newValue);
		if(AreArraysEqualShallow(newValue, oldValue)) return;
    	multiRoute.model.setReferencePoints(newValue);
		oldValue = newValue;
	}, {deep: true});
})

onUnmounted(() => {
	
})
</script>
  
<style scoped>

</style>
